<mat-icon style="float: right"><span (click)="clear()">clear</span></mat-icon>
<div>
  <form *ngIf="login" [formGroup]="loginForm">
    <div class="accordion-class">
      <h6>Transporter Login</h6>
      <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container">
      <div class="group">
        <mat-form-field>
          <mat-label>Mobile</mat-label>
          <input matInput formControlName="mobile" minlength="10" maxlength="10" required
            (keypress)="validateNumber($event)" />
          <mat-error>Please Enter Valid Mobile Number</mat-error>
        </mat-form-field>
      </div>
    </div>
    <button [class.spinner]="loading" [disabled]="loading" type="button" class="button buttonBlue" (click)="sendOTP()">
      Send OTP
    </button>
  </form>
  <form *ngIf="otp" [formGroup]="otpForm">
    <div class="accordion-class">
      <h6>Login</h6>
      <mat-divider></mat-divider>
    </div>
    <div class="login">
      <p>Verify Your Mobile Number</p>
      <h5>{{ loginResponse?.mobile }}</h5>
    </div>
    <div class="group otp-field">
      <ng-otp-input [config]="{ length: 4 }" (onInputChange)="onOtpChange($event)"></ng-otp-input>
      <p *ngIf="loginResponse?.code">Code:{{ loginResponse.code }}</p>
    </div>
    <a class="btn resend_otp" style="text-decoration-line: underline; color: #f29652" (click)="resendOTP()">Resend
      otp</a>
    <div *ngIf="otpWrongErrorMsg" class="otpMsg">
      Please enter the correct otp
    </div>
  </form>
</div>

<div *ngIf="signUp">
  <form [formGroup]="signupForm">
    <div class="accordion-class">
      <h6>Signup</h6>
      <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container mt-0">
      <div class="group mb-0">
        <div class="">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput formControlName="username" required />
            <mat-error>Please Enter Valid Name</mat-error>
          </mat-form-field>
        </div>
        <br />
        <div class="relative">
          <mat-form-field>
            <mat-label>Mobile</mat-label>
            <input matInput formControlName="mobile" [(ngModel)]="verifyData.mobile" readonly />
            <img src="../../../assets/img/tick-verify.svg" />
            <img class="img1" src="../../../assets/img/lock8-icon.png" />
            <mat-error>Please Enter Valid Mobile Number</mat-error>
          </mat-form-field>
        </div>
        <br />
        <!-- <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" />
        </mat-form-field> -->
      </div>
    </div>
    <button type="button" class="button buttonBlue" (click)="Next()">
      Next
    </button>
  </form>
</div>

<div *ngIf="gst">
  <form [formGroup]="GSTForm">
    <div class="accordion-class">
      <h6>Signup</h6>
      <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container mt-0">
      <div class="group mb-0">
        <mat-form-field
          class="mt-3"
          [class.field-locked]="isGstVerified"
          [matTooltip]="isGstVerified ? 'Non-editable' : ''"
          [matTooltipDisabled]="!isGstVerified"
          matTooltipPosition="above"
          [title]="isGstVerified ? 'Non-editable' : ''"
        >
          <mat-label>Company (optional)</mat-label>
          <input
            matInput
            formControlName="company_name"
            [readonly]="isGstVerified"
            [class.input-locked]="isGstVerified"
            [matTooltip]="isGstVerified ? 'Non-editable' : ''"
            [matTooltipDisabled]="!isGstVerified"
            matTooltipPosition="above"
            [title]="isGstVerified ? 'Non-editable' : ''"
          />
          <!-- <mat-error>Please Enter Valid Company Name</mat-error> -->
        </mat-form-field>

        <div class="row mt-3">
          <div class="col-md-6">
            <mat-form-field>
              <mat-label>Designation (optional)</mat-label>
              <input matInput formControlName="designation" />
              <!-- <mat-error>Please Enter Valid Designation</mat-error> -->
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <div
              class="field-verify-wrapper"
              [matTooltip]="isGstVerified ? 'Non-editable' : ''"
              [matTooltipDisabled]="!isGstVerified"
              matTooltipPosition="above"
              [title]="isGstVerified ? 'Non-editable' : ''"
            >
              <mat-form-field [class.field-locked]="isGstVerified">
                <mat-label>Pan (optional)</mat-label>
                <input
                  matInput
                  toUppercase
                  appAlphanumericOnly
                  formControlName="pan"
                  maxlength="10"
                  [readonly]="isGstVerified"
                  [class.input-locked]="isGstVerified"
                  [matTooltip]="isGstVerified ? 'Non-editable' : ''"
                  [matTooltipDisabled]="!isGstVerified"
                  matTooltipPosition="above"
                  [title]="isGstVerified ? 'Non-editable' : ''"
                  (input)="onPanChange()"
                />
                <mat-error>Please Enter Valid Pan Number</mat-error>
              </mat-form-field>
              <div class="verify-addon" *ngIf="GSTForm.controls['pan'].value">
                <div *ngIf="!isPanVerified && !isPanVerifying">
                  <a
                    *ngIf="GSTForm.controls['pan'].value?.length === 10"
                    (click)="verifyPAN()"
                    class="verify-action-link"
                    title="Verify PAN with Master India"
                    >Verify</a
                  >
                </div>
                <div *ngIf="isPanVerifying" class="inline-spinner" title="Verifying PAN..."></div>
                <div *ngIf="isPanVerified" class="verified-badge-inline" title="PAN Verified">
                  <img src="../../../assets/img/tick-verify.svg" alt="Verified" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field-verify-wrapper mt-3">
          <mat-form-field>
            <mat-label>GST (optional)</mat-label>
            <input matInput toUppercase appAlphanumericOnly formControlName="gst" maxlength="15" (input)="onGstChange()" />
            <!-- <mat-error>Please Enter Valid GST NO</mat-error> -->
          </mat-form-field>
          <div class="verify-addon" *ngIf="GSTForm.controls['gst'].value">
            <div *ngIf="!isGstVerified && !isGstVerifying">
              <a
                *ngIf="GSTForm.controls['gst'].value?.length === 15"
                (click)="verifyGST()"
                class="verify-action-link"
                title="Verify GST with Master India"
                >Verify GST</a
              >
            </div>
            <div *ngIf="isGstVerifying" class="d-flex align-items-center">
              <div class="inline-spinner"></div>
              <span style="font-size: 11px; color: #64748b; margin-left: 6px;">Verifying...</span>
            </div>
            <div *ngIf="isGstVerified" class="d-flex align-items-center">
              <div class="verified-badge-inline" title="GST Verified with Master India">
                <img src="../../../assets/img/tick-verify.svg" alt="Verified" />
                <span>Verified</span>
              </div>
              <a
                (click)="editGst()"
                class="change-gst-link"
                title="Click to change and re-verify GST"
                style="margin-left: 8px; font-size: 12px; color: #f58634; font-weight: 500; cursor: pointer; text-decoration: underline;"
                >Change</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="image-upload-view-area">
      <img class="upload_img_size" src="{{ profileImage }}" />
    </div>
    <div *ngIf="profileImg" class="image-upload-area">
      <p>Select your profile picture</p>
      <span (click)="uploadImage.click()" class="image"><img src="../../../assets/img/profile-upload.svg" /></span>
      <input #uploadImage type="file" formControlName="profile_pic" (change)="onChange($event)" hidden />
    </div>
    <!-- <button type="button" class="buttons buttonBlue" (click)="banksForm()">
      <a *ngIf="!profileImage" (click)="banksForm()">Skip</a>

      Next
    </button> -->
    <div class="popupbtn">
      <button type="button" class="button buttonBack" (click)="backToSignUp()">
        Back
      </button>
      <div class="d-flex align-items-center">
        <a *ngIf="!profileImage" (click)="skipGst()" style="margin-right: 20px;">Skip</a>
        <button type="button" class="button buttonBlue" (click)="banksForm()">
          Next
        </button>
      </div>
    </div>
  </form>
</div>
<div *ngIf="bank">
  <form [formGroup]="bankForm">
    <div class="accordion-class">
      <h6>Signup</h6>
      <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container mt-0 mb-2">
      <div class="group mb-0">
        <mat-form-field class="mt-3">
          <mat-label>Account Name</mat-label>
          <input matInput formControlName="account_name" required />
          <!-- <mat-error>Please Enter Account Holder Name</mat-error> -->
        </mat-form-field>
        <mat-form-field class="mt-3">
          <mat-label>Account Number</mat-label>
          <input type="text" matInput maxlength="18" (keypress)="validateNumber($event)"
            formControlName="accountr_number" required />
        </mat-form-field>
        <mat-form-field class="mt-3">
          <mat-label>IFSC Code</mat-label>
          <input matInput toUppercase maxlength="11" appAlphanumericOnly formControlName="ifsc_code" required />
          <!-- <mat-error>Please select IFSC Code</mat-error> -->
        </mat-form-field>
        <div class="row mt-3">
          <div class="col-sm-6">
            <mat-form-field>
              <mat-label>Bank</mat-label>
              <input matInput formControlName="bank_name" required />
              <!-- <mat-error>Please Enter Bank Name</mat-error> -->
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field>
              <mat-label>Branch</mat-label>
              <input matInput formControlName="branch_name" required />
              <!-- <mat-error>Please Enter Branch Name</mat-error> -->
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="image-upload-view-area">
      <img class="upload_img_size" src="{{ chequeImage }}" />
    </div>
    <div *ngIf="chequeImg" class="image-upload-area">
      <p>Upload your cancelled cheque <span style="color: red">*</span></p>
      <span (click)="uploadChequeImage.click()" class="image"><img
          src="../../../assets/img/profile-upload.svg" /></span>
      <input #uploadChequeImage type="file" formControlName="cancelled_cheque" (change)="onChequeChange($event)"
        hidden />
    </div>
    <div class="popupbtn">
      <button type="button" class="button buttonBack" (click)="backToGst()">
        Back
      </button>
      <button type="button" class="button buttonBlue" (click)="Register(1)">
        Register
      </button>
    </div>
  </form>
</div>

<div *ngIf="retrieve_acc" class="container">
  <p>
    {{ message }}
  </p>
  <div class="retrieve_btn mt-3 p_or">
    <button class="yes_btn" (click)="restoreAccount()">
      Restore My Account
    </button>
  </div>
  <p class="mt-3 p_or">or</p>
  <h6 class="text" (click)="newLogin()">Login with New Mobile No</h6>
</div>